import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    incomeStatementList: (type,lesson) => {
        return HTTP.get('/account/report_income_statement?type='+type+'&lesson='+lesson, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}